import React, { useEffect, useRef } from 'react';

type SelectProps = {
    options: Map<string, string>;
    value: string;
    onSelectChange: (newValue: string) => void;
    hasNullValue?: boolean;
    readOnly?: boolean;
};

const SelectDropdown = ({ options, value, onSelectChange, hasNullValue, readOnly}: SelectProps) => {
    const hasRun = useRef(false);
    const selectOptions: JSX.Element[] = [];
    if (hasNullValue) {
        selectOptions.push(<option key="" value=""></option>);
    }
    options.forEach((value, key) => {
        selectOptions.push(<option key={key} value={key}>{value}</option>);
    });

    useEffect(() => {
        if (!hasRun.current && !hasNullValue && !value && options.size) {
            onSelectChange(options.keys().next().value ?? "");
        }
        hasRun.current = true;
      }, [options, onSelectChange, value, hasNullValue]);

    return (
        <select 
            value={value}
            onChange={e => onSelectChange(e.target.value)}
            disabled={readOnly}
            className="border border-gray-300 text-gray-700 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-full p-2 disabled:bg-gray-200">
            {selectOptions}
        </select>
    )
}

export default SelectDropdown;

